import { render, staticRenderFns } from "./StatsB2C2BFilters.vue?vue&type=template&id=d4b9d6b6"
import script from "./StatsB2C2BFilters.vue?vue&type=script&lang=js"
export * from "./StatsB2C2BFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports